module.exports = __webpack_public_path__ + "static/media/nat-1.d6c15bf0.jpg";